module.exports = __webpack_public_path__ + "img/email.86fbcff3.svg";